import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// Search params schema for filter persistence
const ticketsSearchSchema = z.object({
  search: z.string().optional().catch(''),
  status: z.array(z.string()).optional().catch([]),
  priority: z.array(z.string()).optional().catch([]),
  sort: z.enum(['asc', 'desc']).optional().catch('desc'),
  dashboard: z.boolean().optional().catch(false),
  tab: z.enum(['overview', 'activity', 'insights']).optional().catch('overview'),
  // My requests, or the tickets the customer is a participant on
  scope: z.enum(['mine', 'participating']).optional().catch('mine'),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
});
import { CustomerPortalTickets } from '../../../../../customer-portal/pages/CustomerPortalTickets';
import { checkCustomerAuthentication, validateOrganization } from '../../../../../lib/portal-loaders';
import { usePortalContext } from '../../../../../contexts/PortalContext';

function PortalTicketsList() {
  const { organizationInfo } = usePortalContext();

  return (
    <CustomerPortalTickets
      organizationInfo={organizationInfo}
    />
  );
}

export const Route = createFileRoute('/org/$orgSlug/portal/tickets/')({
  validateSearch: ticketsSearchSchema,
  beforeLoad: async ({ params }) => {
    const orgSlug = params.orgSlug as string;

    try {
      // Validate organization and get organization info
      const organizationInfo = await validateOrganization(orgSlug);

      // Check if user has valid customer authentication for this organization
      if (!checkCustomerAuthentication(organizationInfo.organizationId)) {
        throw redirect({
          to: '/org/$orgSlug/portal/login',
          params: { orgSlug: params.orgSlug },
        });
      }
    } catch {
      // If organization validation or authentication fails, redirect to login
      throw redirect({
        to: '/org/$orgSlug/portal/login',
        params: { orgSlug: params.orgSlug },
      });
    }
  },
  component: PortalTicketsList,
});